// @flow
import React from "react"
import moment from "moment"
import { compose } from "react-apollo"
import { Prompt } from "react-router-dom"
import { Helmet } from "react-helmet"
import { Toolbar, Heading } from "../UI/Toolbar"
import { Page } from "../UI/Page"
import KioskForm from "./KioskForm"
import queries from "./queries"
import { mapKioskDates } from "./helpers"
import Loader from "../UI/Loader"
import type { KioskFormViewProps } from "./types"
import handleSubmit from "./handleSubmit"
import { confirmDeletePath } from "./helpers"

type State = {
  isBlocking: boolean,
  inviteLoading: boolean,
  inviteSentAt: ?string
}

class KioskFormView extends React.Component<KioskFormViewProps, State> {
  constructor(props) {
    super(props)
    this.state = { isBlocking: false, inviteLoading: false, inviteSentAt: "" }
  }

  handleChange(e) {
    this.setState(() => ({ isBlocking: true }))
  }

  async handleInvite() {
    const { inviteKiosk, match: { params: { id } } } = this.props
    this.setState(() => ({ inviteLoading: true }))
    let inviteSentAt = null
    try {
      const confirmation = await inviteKiosk(id)
      inviteSentAt = moment(confirmation.sentAt).format("h:mmA")
    } catch (error) {
      console.log(error)
    }
    this.setState(() => ({ inviteLoading: false, inviteSentAt }))
  }

  componentDidUpdate(prevProps, prevState) {
    const { details } = this.props
    if (
      prevProps.details &&
      prevProps.details.loading &&
      details &&
      !details.loading
    ) {
      this.setState(() => ({ isBlocking: false }))
    }
  }

  render() {
    const {
      createKiosk,
      updateKiosk,
      history: { push },
      match: { params: { id } },
      details,
      options: { sensors, attractLoops }
    } = this.props
    const { isBlocking, inviteLoading, inviteSentAt } = this.state
    const currentSensor =
      details && details.kiosk ? details.kiosk.primarySensor : null
    const gasPreviewUrl = currentSensor ? currentSensor.gasUrl : null
    const particlesPreviewUrl = currentSensor
      ? currentSensor.particlesUrl
      : null

    return (
      <Page>
        <Helmet>
          <title>
            {`Kiosks - ${details
              ? `${details.kiosk ? details.kiosk.friendlyName : "Editing"}`
              : "New"}`}
          </title>
        </Helmet>
        <Prompt
          when={isBlocking}
          message={location =>
            `Are you sure you want to leave this form and lose any unsaved changes?`}
        />
        <Loader loading={details ? details.loading : false}>
          <Toolbar>
            <Heading>
              {id && details
                ? `Editing: ${details.kiosk ? details.kiosk.friendlyName : ""}`
                : "New Kiosk"}
            </Heading>
          </Toolbar>
          <KioskForm
            loading={details ? details.loading : true}
            initialValues={
              details
                ? mapKioskDates(details.kiosk)
                : { language: "English", hidden: false }
            }
            sensors={sensors}
            attractLoops={attractLoops}
            onSubmit={handleSubmit(id, createKiosk, updateKiosk, () => {
              this.setState(() => ({ isBlocking: false }))
              push("/admin/kiosks")
            })}
            onChange={e => this.handleChange(e)}
            handleCancel={event => {
              event.preventDefault()
              push("/admin/kiosks")
            }}
            handleDelete={async event => {
              event.preventDefault()
              await this.setState(() => ({
                isBlocking: false
              }))
              push(confirmDeletePath(id))
            }}
            isNew={id ? false : true}
            id={id}
            handleInvite={() => this.handleInvite()}
            inviteLoading={inviteLoading}
            lastInviteSent={inviteSentAt}
            gasPreviewUrl={gasPreviewUrl}
            particlesPreviewUrl={particlesPreviewUrl}
          />
        </Loader>
      </Page>
    )
  }
}

export default compose(
  queries.withKioskFormDetails,
  queries.withKioskFormOptions,
  queries.mutateCreateKiosk,
  queries.mutateUpdateKiosk,
  queries.mutateInviteKiosk
)(KioskFormView)



// WEBPACK FOOTER //
// ./src/Kiosks/KioskFormView.js